<template>
  <div>
    <v-select
      v-model="selectedItem"
      :items="items"
      item-text="nome"
      item-value="id"
      outlined
      append-inner-icon="mdi-magnify"
      dense
      hide-details
    />
  </div>
</template>

<script>
import LocalExecucaoService from '@/common/services/cadastros/LocalExecucaoService';

export default {
    props:{
        criterio: {
        default: '',
        required: false,
        }
    },
    data() {
        return {
            selectedItem: null,
            items: [],
            loading: false
        };
    },
    watch:{
        selectedItem(valor){
            let result = this.items.find(item => item.id === valor)

            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            if(itemEncontrado) {
                itemEncontrado.localExecucao = result
                itemEncontrado.localExecucaoId = result.id
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        }
    },
    async mounted() {
        await this.fetchData();
        this.setup();
    },
    methods: {
        setup(){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)
            
            if(itemEncontrado) {
                this.selectedItem = itemEncontrado.localExecucao
                itemEncontrado['localExecucaoId'] = itemEncontrado.localExecucao.id
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});

            }
        },
        async fetchData() {
            this.loading = true;
            if (this.items.length) {
                this.loading = false;
                return
            }
            try {
                let {data} = await LocalExecucaoService.listar();

                if (data) {
                    this.items = data.items
                } else {
                    console.warn('A resposta do serviço não contém dados ou a estrutura não é a esperada.', data);
                    return [];
                }
            } catch (error) {
                console.error('Erro ao buscar dados do serviço de Local de Execução:', error);
                return [];
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
